import { IUserContext, userContext } from "@siruplab/capsule"
import { useContext } from "react"

import { UserData } from "../features/models/UserData"

const useUserData = () => useContext<IUserContext<UserData>>(userContext)

export default useUserData
